import BarcodeReaderInput   from '@/components/fields/barcode-reader-input.vue';
import MoneyField           from '@/components/fields/money-field.vue';
import { validationMixin } from 'vuelidate';
import { required, maxLength, email, requiredIf } from 'vuelidate/lib/validators';

export default {
    components : {
        BarcodeReaderInput,
        MoneyField
    },
    mixins: [validationMixin],

    validations: {
        fieldSerialNumber    : {
            required : requiredIf(function (model) {
                if (this.selectedProductInfos.length > 0) {
                    return true;
                }
                return false;
            }),
            maxLength : maxLength(50)
        },
    },
    props: {
        productInfos       :  {
            type    : Object,
            default : {}
        },
    },
    data () {
        return {
            toggleProductReplacement: false,
            selectedProductInfos    : [],
            productPrice            : null,
        };
    },
    watch: {
        productInfos(product) {
            console.info('watch', product);
           let productInfo = {};
            productInfo =  {
                'detail'    : product.inventorynumber,
                'label'     : 'Inventurnummer'
            };
            this.selectedProductInfos.push(productInfo);
            productInfo =  {
                'detail'    : product.eannumber,
                'label'     : 'EAN Nummer'
            };
            this.selectedProductInfos.push(productInfo);
            productInfo =  {
                'detail'    : product.brandName,
                'label'     : 'Marke'
            };
            this.selectedProductInfos.push(productInfo);
            productInfo =  {
                'detail'    : product.name[this.$i18n.locale],
                'label'     : 'Modell'
            };
            this.selectedProductInfos.push(productInfo);
        },

    },
    methods : {
        resetValues() {
            console.info('reset values');
            this.selectedProductInfos   = [];
            this.$refs.fieldSerialNumber.resetValue();
        },
        getValues() {
            let ret = {};
            ret.inventoryNumber  = this.productInfos.inventorynumber;
            ret.eanNumber        = this.productInfos.eannumber;
            ret.brandName        = this.productInfos.brandName;
            ret.productName      = this.productInfos.name[this.$i18n.locale];
            ret.serialNumber     = this.$refs.fieldSerialNumber.getValue();
            ret.productPrice     = this.productPrice;

            console.warn('values', ret);

            return ret;
        },
    },
    computed: {
        fieldSerialNumberErrors () {
            const errors = [];
            if (!this.$v.fieldSerialNumber.$dirty) {
                return errors;
            }
            if (!this.$v.fieldSerialNumber.maxLength) {
                errors.push('fieldSerialNumber must be at most 50 characters long');
            }
            if (!this.$v.fieldSerialNumber.required) {
                errors.push('fieldSerialNumber is required.');
            }
            return errors;
        },
    },

};
